/* eslint-disable prettier/prettier */
/* eslint-disable import/order */
import { FC } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { Button, Stack, TextField } from '@mui/material';
import { Form } from '@bvi/common-components';
import { useCreateDamageMutation } from '@bvi/admin-panel/entities/damage/api-slice';

interface IAddDamageFormProperties {
  onSuccess: () => void;
}

interface IAddDamageFormValues {
  name: string;
}

export const AddDamageForm: FC<IAddDamageFormProperties> = ({
  onSuccess,
}) => {
  const { t } = useTranslation('translation');
  const [createDamage, { isLoading: isCreatingDamage }] = useCreateDamageMutation();

  const validationSchema = z.object({
    name: z.string().min(1, t('manageList.form.fields.name.label') as string),
  });

  const methods = useForm<IAddDamageFormValues>({
    resolver: zodResolver(validationSchema),
    defaultValues: {
      name: '',
    },
  });

  const onSubmit = async (data: IAddDamageFormValues) => {
    try {
      await createDamage(data).unwrap();
      onSuccess();
    } catch {
      // Error handling - mutation will show error state
    }
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={methods.handleSubmit(onSubmit)}>
        <Stack spacing={2}>
          <TextField
            {...methods.register('name')}
            label={t('manageList.form.fields.name.label')}
            placeholder={t('manageList.form.fields.name.placeholder')}
            error={Boolean(methods.formState.errors.name)}
            helperText={methods.formState.errors.name?.message}
            fullWidth
          />
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              variant="outlined"
              onClick={onSuccess}
              disabled={isCreatingDamage}
            >
              {t('manageList.form.actions.cancel.caption')}
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={isCreatingDamage}
            >
              {t('manageList.form.actions.save.caption')}
            </Button>
          </Stack>
        </Stack>
      </Form>
    </FormProvider>
  );
};

